/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { Utility } from '@/utils/TimeUtils'
import { MsgIDs } from '@/defines/MsgIDs'
import { WebDefine } from '@/defines/WebDefine'
import { md5 } from '@/utils/md5'
import { wsClient } from '@/net/WebSocketClient'
import * as proto from '@/proto/proto.js'
import { log } from '@/utils/functions'

export class RegisterModule extends ModuleBase {
  public timePanel: any = null

  //注册协议
  init(): void {}

  onClear(): void {
    if (hall.registerModule.timePanel) {
      Utility.cancelTimer(hall.registerModule.timePanel)
    }
    hall.registerModule.timePanel = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClient2ProxyRegisterAck'] = (msg: proto.Client2ProxyRegisterAck) => {
      //int32 		Ret			    = 1;    //错误码
      if (hall.registerModule.timePanel) {
        base.uiHudSystem.hide('SystemWaitingCopy')
        Utility.cancelTimer(hall.registerModule.timePanel)
        hall.registerModule.timePanel = null
      }

      if (msg.Ret == 0) {
        hall.loginModule.isFirstLogin = true
        hall.eventDispatcher.emit(hall.EventDefine.OnRegisterChange)
        if ((globalThis as any).fbEvent) {
          (globalThis as any).fbEvent('CompleteRegistration')
        }
      } else if (msg.Ret == 134) {
        //用户已存在
        hall.eventDispatcher.emit(hall.EventDefine.OnRegisterUserErr) //注册错误 - 玩家输入账号已存在
      } else if (msg.Ret == 135) {
        hall.eventDispatcher.emit(hall.EventDefine.OnRegisterPhoneErr) //注册错误 - 手机号码错误
      } else if (msg.Ret == 55) {
        //注册上限（同个设备只能注册X个账号）
        base.toast(hall.Language.ResigsterError)
      } else {
        //其他报错
        hall.eventDispatcher.emit(hall.EventDefine.OnRegisterUserErr) //注册错误 - 玩家输入账号已存在
        hall.eventDispatcher.emit(hall.EventDefine.OnRegisterPhoneErr) //注册错误 - 手机号码错误
      }
    }

    ;(hall.s2c as any)['onClient2ProxyLoggingAck'] = (msg: proto.Client2ProxyLoggingAck) => {
      // int32 		Ret			    = 1;    //错误码
      // string      Token           = 2;    //Token
      if (hall.registerModule.timePanel) {
        base.uiHudSystem.hide('SystemWaitingCopy')
        Utility.cancelTimer(hall.registerModule.timePanel)
        hall.registerModule.timePanel = null
      }
      if (msg.Ret == 0) {
        base.app.token = msg.Token
        hall.eventDispatcher.emit(hall.EventDefine.OnLoginChange)
      } else if (msg.Ret == 32) {
        //用户不存在
        hall.eventDispatcher.emit(hall.EventDefine.OnLoginChangeErr) //登录账号错误 - 用户不存在
      } else if (msg.Ret == 136) {
        // 密码错误
        hall.eventDispatcher.emit(hall.EventDefine.OnLoginPassErr) //登录账号错误 - 密码错误
      } else {
        hall.eventDispatcher.emit(hall.EventDefine.OnLoginChangeErr) //登录账号错误 - 用户不存在
        hall.eventDispatcher.emit(hall.EventDefine.OnLoginPassErr) //登录账号错误 - 密码错误
      }
    }
  }

  showSystemWaitingCopy() {
    if (hall.registerModule.timePanel == null) {
      // 当前是点了没反应，要等几秒才会加载。
      // 修改为：
      // 正常：点了转菊花，有数据时再进入页面。
      // 异常：若转菊花超过15s，或者没有数据返回，停止转菊花Toast提示“Data error”

      base.uiHudSystem.show('SystemWaitingCopy', hall.Language.Loggings)
      const err = function () {
        base.toast(hall.Language.panelShowErroe)
        base.uiHudSystem.hide('SystemWaitingCopy')
        if (hall.registerModule.timePanel) {
          Utility.cancelTimer(hall.registerModule.timePanel)
        }
        hall.registerModule.timePanel = null
      }

      hall.registerModule.timePanel = Utility.scheduleOnce(err, 10)
    }
  }

  //请求注册
  sendRegister(account: string, password: string, phone: string) {
    //      string      RegAccount      = 1;    // 注册账号
    // string      PassWord        = 2;    // 注册密码
    // string		modileNum		= 3; 	// 手机号
    // string		clientMark		= 4; 	// 客户端唯一标识
    // int32		platformType	= 5;	// 平台类型 1:android  2:ios 3:pc
    // int32		platform		= 6;	// 平台编号 暂时无用  多平台可能需要
    // int32		regChannel		= 7;	// 注册渠道
    // string    	version			= 8; 	// 客户端版本号
    // int32 		appVersion		= 9;	// 客户端更新版本号
    // int32       Type			= 10; 	// 保留字段
    // uint32   	RecommendedUID	= 11; 	// 推荐ID
    // string      AppName         = 12;   // 包名
    // uint32		channel	        = 13;   // 渠道类型 1:google;2:其它保留项;
    // string		mobileType 	    = 14;	// 手机型号
    // string		mobileOsVer	    = 15;	// 手机系统版本号
    this.showSystemWaitingCopy()
    const message = {
      RegAccount: account,
      PassWord: password,
      modileNum: phone,
      clientMark: base.app.getUUID(), // 客户端唯一标识
      platformType: base.app.getPlatformType(), // 平台类型 1:android  2:ios 3:pc
      regChannel: base.channelId,
      channel: base.channelId,
      version: base.app.version,
      //CheckLogin: "LaMiLeiSi@20220901",
    }
    wsClient.send(MsgIDs.Client2ProxyRegisterReq, message)
  }

  //请求账号登录
  sendLogging(account: string, password: string) {
    //   string      RegAccount      = 1;    // 注册账号
    //string      PassWord        = 2;    // 注册密码
    this.showSystemWaitingCopy()
    const message = {
      RegAccount: account,
      PassWord: password,
    }
    wsClient.send(MsgIDs.Client2ProxyLoggingReq, message)
  }

  //更改密码用户名手机号码等
  sendUpdateUserInfoNoSign(regaccount: string, uid: string | number, password?: string, phone?: string): void {
    const token = this.profileTokenChange(uid as string)

    let data = {}
    if (password) {
      data = {
        password: password,
        regaccount: regaccount,
        token: token,
        uid: Number(hall.userModule.userId),
      }
    } else if (phone) {
      data = {
        phone: phone,
        regaccount: regaccount,
        token: token,
        uid: Number(hall.userModule.userId),
      }
    }

    base.httpUtil
      .postJson(WebDefine.updateUserInfoNoSign, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          if (respJson.data) {
            if (respJson.data['mobile']) {
              hall.userModule.userphone = respJson.data['mobile']
            }
            if (respJson.data['regaccount']) {
              hall.userModule.regaccount = respJson.data['regaccount']
            }
          }
          hall.eventDispatcher.emit(hall.EventDefine.OnForgotPassChange) //忘记密码新密码返回
          hall.eventDispatcher.emit(hall.EventDefine.OnNewProfileChange) //重置手机号码正确返回
          hall.eventDispatcher.emit(hall.EventDefine.OnRecgatgePhoneChange) //支付修改手机号 -- 手机号修改成功回调
        } else if (respJson.code == 549) {
          hall.eventDispatcher.emit(hall.EventDefine.OnNewProfilePhoneErr) //重置手机号码-- - 输入的手机号已被使用
          hall.eventDispatcher.emit(hall.EventDefine.OnRecgatgePhoneErr) //支付修改手机号-- - 手机号与原始手机号不一致
        } else {
          base.toast(respJson.msg)
        }
      })
      .catch((error) => {
        log('error:requestVipEquity', error)
      })
  }
  //核对玩家手机号码账号(忘记密码跟修改手机号同用一个接口)
  sendCheckUserInfoNoSign(regaccount: string, phone: string): void {
    const data = {
      regaccount: regaccount,
      phone: phone,
    }
    base.httpUtil
      .postJson(WebDefine.checkUserInfoNoSign, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.OnForgotChange) //忘记密码账号正确返回
          hall.eventDispatcher.emit(hall.EventDefine.OnProfileChange) //验证自己的手机号码正确返回
        } else if (respJson.code == 547) {
          // RegAccount already exist 注册账号不存在
          hall.eventDispatcher.emit(hall.EventDefine.OnForgotUserErr) //忘记密码 - 玩家输入账号不存在
        } else if (respJson.code == 550) {
          // RegAccount already exist 注册账号已存在
          //hall.eventDispatcher.emit(hall.EventDefine.OnForgotUserErr); //忘记密码 - 玩家输入账号不存在
        } else if (respJson.code == 548) {
          // User phone does not exist 玩家手机号不存在
          hall.eventDispatcher.emit(hall.EventDefine.OnProfilePhoneErr) //重置手机号码-- - 手机号与原始手机号不一致
          hall.eventDispatcher.emit(hall.EventDefine.OnForgotUserAndPhoneErr) //忘记密码-- - 账号与手机号码不匹配
          //hall.eventDispatcher.emit(hall.EventDefine.OnForgotPhoneErr); //忘记密码-- - 手机号码不存在
        } else {
          base.toast(respJson.msg)
        }
      })
      .catch((error) => {
        log('error:requestVipEquity', error)
      })
    // "code": 200,
    // "msg": "success",
    // "data": {
    //   "uid": "1",
    //   "username": "12154545",
    //   "name": "吴系挂",
    //   "groupid": 2 ,
    //   "reg_time": "1436864169",
    //   "last_login_time": "0",
  }

  // 获取指定 Cookie 值的函数
  getCookie(name: string): string | null {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null
    return null
  }

  //发送fb参数绑定
  bindphoneFb(eventName: string) {
    // 获取 fbp 和 fbc

    const userAgent = navigator.userAgent
    const fbp = this.getCookie('_fbp')
    const fbc = this.getCookie('_fbc')
    let action_source = 'Website'
    const event_name = eventName
    if (sys.isNative) {
      //H5和PWA写Website，APK写app
      action_source = 'app'
    }

    const payload = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      fbp: fbp,
      fbc: fbc,
      action_source: action_source,
      client_user_agent: userAgent,
      event_name: event_name,
    }
    const fist_load_url = localStorage.getItem('fist_load_url')
    if (fist_load_url) {
      const url = new URL(fist_load_url)
      const arrRet = new URLSearchParams(url.search)
      arrRet.forEach((value, key) => {
        (payload as any)[key] = value
      })
    }

    base.httpUtil
      .postJson(WebDefine.fbReportCharge, payload)
      .then((respJson) => {
        if (respJson.code == 200) {
          log('fbReportChargeSuccess')
        } else {
          log('error:bindphoneFb')
        }
      })
      .catch((error) => {
        log('error:bindphoneFb', error)
      })
  }

  //绑定手机号
  sendBindPhoneNoCode(regaccount: string, password: string, phone: string): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      regaccount: regaccount,
      password: password,
      phone: phone,
    }
    base.httpUtil
      .postJson(WebDefine.BindUserInfoNoCode, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.OnBindPhoneChange) //绑定手机号 -- 成功返回
          this.bindphoneFb('CompleteRegistration')
          if ((globalThis as any).fbEvent) {
            (globalThis as any).fbEvent('CompleteRegistration')
          }
        } else if (respJson.code == 549 || respJson.code == 529) {
          // Phone already exist 手机号已存在
          hall.eventDispatcher.emit(hall.EventDefine.OnBindPhoneError) ///绑定手机号-- -  输入的手机号已被使用
        } else if (respJson.code == 550) {
          // RegAccount already exist 注册账号已存在
          hall.eventDispatcher.emit(hall.EventDefine.OnBindPhoneUserError) ///绑定手机号-- - 玩家输入账号已存在
        } else if (respJson.code == 551) {
          // Password cannot be empty 密码不能为空
        } else {
          base.toast(respJson.msg)
        }
      })
      .catch((error) => {
        log('error:requestVipEquity', error)
      })
  }

  profileTokenChange(tokenStr: string): string {
    const concatenatedString = `${'xzg19491001'}${tokenStr}`
    // 4. 计算MD5哈希
    const md5Str = md5(concatenatedString)
    return md5Str
  }
}
